import { render } from "./GestaoMenuSubmenuDetalhe.vue?vue&type=template&id=2bf687b0&scoped=true"
import script from "./GestaoMenuSubmenuDetalhe.vue?vue&type=script&lang=js"
export * from "./GestaoMenuSubmenuDetalhe.vue?vue&type=script&lang=js"

import "./GestaoMenuSubmenuDetalhe.vue?vue&type=style&index=0&id=2bf687b0&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf687b0"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QLinearProgress,QTable,QTr,QTh,QTd,QBtn,QPagination,QSeparator,QSelect});
